// extracted by mini-css-extract-plugin
export default {"PriceMarkerV2":"PriceMarkerV2_PriceMarkerV2__MWJhY","PriceMarkerV2__marker":"PriceMarkerV2_PriceMarkerV2__marker__ZWRmN"};